/*
 * Pinned experience entry — always shown first, regardless of what admin
 * panel entries get added/inserted on top of it in Firestore or the JSON fallback.
 */
export const PINNED_EXPERIENCE = {
  role: "SIL Trainee (TESDA 120 Hours) — AI/Full-Stack Developer",
  company: "EACOMM Corporation",
  date: "2026",
  description: "Completed a 120-hour Supervised Industrial Learning (SIL) program under TESDA at EACOMM Corporation. My best contribution was building Cognexa, a hybrid AI-powered platform combining a RAG knowledge base with AI-driven SDLC, which was featured in EACOMM's published whitepaper on AI-assisted software development.",
  tasks: [
    "Completed 120 hours of Supervised Industrial Learning (SIL) under TESDA requirements",
    "Built Cognexa, a hybrid AI-powered platform with a RAG knowledge base and AI-driven SDLC support",
    "Implemented both self-hosted (local LLM via Ollama) and cloud (bring-your-own-key) operating modes",
    "Contributed to EACOMM Corporation's published research on AI-assisted software development",
    "Strongest at combining RAG knowledge retrieval with practical, AI-driven development workflows"
  ]
}
